class ButtonCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.color = options?.color ? false
        @.disabled = options?.disabled ? false
        @.download = options?.download ? false
        @.icon = options?.icon ? false
        @.iconBefore = options?.iconBefore ? false
        @.id = options?.id ? false
        @.link = options?.link ? false
        @.outline = options?.outline ? false
        @.primary = options?.primary ? false
        @.tag = if @.link then 'a' else (options?.tag ? 'button')
        @.target = if options?.download then '_blank' else (if options?.link && options?.target then options.target else false)
        @.text = options?.text ? 'Button-Text'
        @.title = options?.title ? false
        @.type = options?.type ? 'button'

        @.CreateElement()
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement @.tag
        @.$el.classList.add 'button'
        if @.outline
            @.$el.classList.add 'button--outline'
        if @.primary
            @.$el.classList.add 'button--primary'
        if @.iconBefore
            @.$el.classList.add 'button--icon-before'
        if @.tag == 'button'
            @.$el.type = @.type
            if @.disabled
                @.$el.disabled = true
        if @.color
            @.$el.classList.add "button--#{ @.color }"
        if @.title
            @.$el.title = @.title
            @.$el.setAttribute 'aria-label', @.title
        if @.tag == 'a' && @.link
            @.$el.href = @.link
        if @.tag != 'button' && @.disabled
            @.$el.classList.add 'button--disabled'
        if @.id
            @.$el.id = @.id
        if @.download
            @.$el.setAttribute 'download', ''
        if @.target
            @.$el.target = @.target
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        @.$el.innerHTML = "
            <span class='button__text'>#{ @.text }</span>
        "
        if @.icon
            @.$el.appendChild window.CreateIcon @.icon
        
        return

window.CreateButton = (options) ->
    return new ButtonCreate options